import ModulePlanningClassModelBase from '../_generated/modelBases/module-planning-class-model-base';

export default class ModulePlanningClassModel extends ModulePlanningClassModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
